import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=71032427&scoped=true&lang=html&"
import script from "./basicInfo.vue?vue&type=script&lang=js&"
export * from "./basicInfo.vue?vue&type=script&lang=js&"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=71032427&lang=scss&scoped=true&"
import style1 from "./basicInfo.vue?vue&type=style&index=1&lang=scss&media=screen&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71032427",
  null
  
)

export default component.exports